module.exports = __webpack_public_path__ + "static/media/marshal.eff09445.png";